// A soft jazz loop runs underneath; each scene adds its own ambience on top
// with crossfades. Files live in /public/sounds; a missing file simply stays
// silent, so the page never breaks on audio.
const BEDS = {
  dusk: '/sounds/dusk.mp3',     // café terrace, distant street
  fire: '/sounds/fire.mp3',     // wood fire, sizzling pan
  table: '/sounds/table.mp3',   // friends at the table, cutlery
  bar: '/sounds/bar.mp3',       // ice, pouring, low room
  night: '/sounds/night.mp3',   // quiet night, a far piano
};
const MUSIC = '/sounds/jazz.mp3';
const ONESHOTS = { clink: '/sounds/clink.mp3' };
const BED_VOLUME = 0.22;
const MUSIC_VOLUME = 0.32;

class SoundDirector {
  constructor() {
    this.enabled = false;
    this.beds = {};
    this.current = null;
    this.fades = {};
  }

  bed(name) {
    if (!this.beds[name]) {
      const a = new Audio(BEDS[name]);
      a.loop = true;
      a.preload = 'auto';
      a.volume = 0;
      a.addEventListener('error', () => { a.dataset.broken = '1'; });
      this.beds[name] = a;
    }
    return this.beds[name];
  }

  fade(a, to, ms = 1400) {
    const key = a.src;
    cancelAnimationFrame(this.fades[key]);
    const from = a.volume;
    const start = performance.now();
    const step = (now) => {
      const k = Math.min(1, (now - start) / ms);
      a.volume = from + (to - from) * k;
      if (k < 1) this.fades[key] = requestAnimationFrame(step);
      else if (to === 0) a.pause();
    };
    this.fades[key] = requestAnimationFrame(step);
  }

  // Must be called from a user gesture (tap) so browsers allow playback.
  enable() {
    this.enabled = true;
    if (!this.music) {
      this.music = new Audio(MUSIC);
      this.music.loop = true;
      this.music.volume = 0;
    }
    this.music.play().then(() => this.fade(this.music, MUSIC_VOLUME, 2000)).catch(() => {});
    if (this.current) this.scene(this.current, true);
  }

  disable() {
    this.enabled = false;
    Object.values(this.beds).forEach((a) => this.fade(a, 0, 500));
    if (this.music) this.fade(this.music, 0, 500);
  }

  scene(name, force = false) {
    if (!BEDS[name] || (name === this.current && !force)) return;
    const prev = this.current;
    this.current = name;
    if (!this.enabled) return;
    if (prev && prev !== name) this.fade(this.bed(prev), 0);
    const a = this.bed(name);
    if (a.dataset.broken) return;
    a.play().then(() => this.fade(a, BED_VOLUME)).catch(() => {});
  }

  once(name) {
    if (!this.enabled) return;
    const src = ONESHOTS[name];
    if (!src) return;
    const a = new Audio(src);
    a.volume = 0.9;
    a.play().catch(() => {});
  }
}

export const sound = new SoundDirector();
